import { Theme, ThemeMap } from 'common-types'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import Grade06 from '../grades/Grade06'
import Grade07 from '../grades/Grade07'
import Grade08 from '../grades/Grade08'

interface Props {
	language: 'english' | 'spanish'
	data: ThemeMap
	grades: number[]
}

export default function ThemeMapGradesMiddleSchool({ language, data, grades }: Props) {
	const { account } = useContext(CoreAdoptionContext)
	const standard = account ? (account?.standard.toUpperCase() as 'CCSS' | 'TEKS') : 'CCSS'

	const [themeUnit, setThemeUnit] = React.useState('')

	const changeTheme = (id: string) => {
		if (id === themeUnit) setThemeUnit('')
		else setThemeUnit(id)
	}

	return (
		<>
			<div className="ml-0 flex md:ml-6">
				<p className="w-1/4 text-center font-bold text-slate-800">Unit 1 </p>
				<p className="w-1/4 text-center font-bold text-slate-800">Unit 2</p>
				<p className="w-1/4 text-center font-bold text-slate-800">Unit 3</p>
				<p className="w-1/4 text-center font-bold text-slate-800">Unit 4</p>
			</div>
			<div>
				<div className="ml-0 mt-4 flex md:ml-6">
					<p className="w-1/4 text-center text-xs font-bold text-slate-800 sm:text-base">Literary Analysis Lab</p>
					<p className="w-1/4 text-center text-xs font-bold text-slate-800 sm:text-base">Informational</p>
					<p className="w-1/4 text-center text-xs font-bold text-slate-800 sm:text-base">Genre</p>
					<p className="w-1/4 text-center text-xs font-bold text-slate-800 sm:text-base">Argument</p>
				</div>

				{data.grade6 && grades.includes(6) && (
					<Grade06 themes={data.grade6 as Theme[]} middleSchool language={language} themeUnit={themeUnit} changeTheme={changeTheme} standard={standard} />
				)}
				{data.grade7 && grades.includes(7) && (
					<Grade07 themes={data.grade7 as Theme[]} language={language} themeUnit={themeUnit} changeTheme={changeTheme} standard={standard} />
				)}
				{data.grade8 && grades.includes(8) && (
					<Grade08 themes={data.grade8 as Theme[]} language={language} themeUnit={themeUnit} changeTheme={changeTheme} standard={standard} />
				)}
			</div>
		</>
	)
}
